import React, {Fragment} from "react";
import ModalConfirm from "../../../components/ModalConfirm";
import ModalMsg from "../../../components/ModalMsg";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import NsButtonAction from "../../../components/buttons/NsButtonAction";
import NsButtonActionsGroup from "../../../components/buttons/NsButtonActionsGroup";
import Sidebar from "../../../components/Sidebar";
import NsAccordion from "../../../components/accordion/NsAccordion";

export default function ConfStrutturaClassiMacrocategorieView({
                                                                  data,
                                                                  showConfirm,
                                                                  setShowConfirm,
                                                                  eliminaStrClasse,
                                                                  translate,
                                                                  strMacrSel,
                                                                  show,
                                                                  setShow,
                                                                  modalMsg,
                                                                  isMobile,
                                                                  getAlberoStruttura,
                                                                  onClickElimina,
                                                              }) {

    return (
        <Fragment>
            <ModalConfirm
                show={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleOk={eliminaStrClasse}
                testo={translate("Sicuro di voler eliminare la struttura classe macrocategoria: ") + (strMacrSel && (strMacrSel.classe_macrocategoria_madre
                    + ' - ' + strMacrSel.classe_macrocategoria)) + "?"}/>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Sidebar
                sidebarContent={() => {
                    return isMobile ?
                        <NsAccordion
                            titolo={'Struttura Classi'}
                            label={'fas fa-stream'}>
                            {
                                getAlberoStruttura()
                            }
                        </NsAccordion>
                        : getAlberoStruttura()
                }}
            >
                <NsDataTable
                    data={data}
                    columns={[
                        {
                            name: translate('Padre'),
                            selector: row => row.classe_macrocategoria_madre,
                            sortable: true,
                        },
                        {
                            name: translate('Classe'),
                            selector: row => row.classe_macrocategoria,
                            sortable: true,
                        },
                        {
                            name: '',
                            selector: row => <NsButtonActionsGroup>
                                <li>
                                    <NsButtonAction
                                        label={"Elimina"}
                                        icona={"fas fa-trash"}
                                        onClick={() => {
                                            onClickElimina(row);
                                        }}
                                    />
                                </li>
                            </NsButtonActionsGroup>,
                            sortable: false,
                            right: true,
                        }
                    ]}
                />
            </Sidebar>
        </Fragment>
    );
}